/** Cronómetro de twilio.chats.unico al abrir un chat. */
export default {
  data: () => ({
    tiempoCargaChatMs: null,
  }),

  methods: {
    iniciarTiempoCargaChat () {
      this.tiempoCargaChatMs = null
      return performance.now()
    },

    finalizarTiempoCargaChat (t0) {
      if (t0 == null) return
      this.tiempoCargaChatMs = Math.round(performance.now() - t0)
    },

    limpiarTiempoCargaChat () {
      this.tiempoCargaChatMs = null
    },
  },
}
